import { FC } from "react";
import { Button, Flex, Text } from "@chakra-ui/react";

import { CASE_FILE_KIND } from "@shared/models";
import { AddIcon } from "@shared/components/Icons";
import { CASE_DOCUMENT_INFO } from "@containers/Cases/constants";
import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";

interface CaseDocumentEmptyCardProps {
  kind: CASE_FILE_KIND;
  onAdd?: () => void;
  /** Shown under the button while it's disabled */
  addHint?: string;
}

const CaseDocumentEmptyCard: FC<CaseDocumentEmptyCardProps> = ({ kind, onAdd, addHint }) => {
  const { title, multipleFiles, description, addLabel } = CASE_DOCUMENT_INFO[kind];

  return (
    <Flex
      direction="column"
      gap="10px"
      p="18px"
      borderRadius="10px"
      border="1.5px dashed"
      borderColor="gray.200"
      bg="brand.bg"
    >
      <Flex direction="column" gap="2px">
        <Text fontSize="15px" fontWeight={FONT_WEIGHT.HEAVY} color="brand.modalHeaderText">
          {title}
        </Text>
        <Text fontSize="12px" color="brand.emptyStateText">
          Optional · {multipleFiles ? "multiple files" : "one file"}
        </Text>
      </Flex>
      <Text fontSize="13px" lineHeight={1.5} color="brand.emptyStateText">
        {description}
      </Text>
      <Button
        variant="outline"
        alignSelf="flex-start"
        mt="auto"
        h="36px"
        px="14px"
        fontSize="14px"
        bg="brand.white"
        _icon={{ boxSize: "14px" }}
        disabled={!onAdd}
        onClick={onAdd}
      >
        <AddIcon />
        {addLabel}
      </Button>
      {!onAdd && addHint && (
        <Text fontSize="12px" color="brand.emptyStateText">
          {addHint}
        </Text>
      )}
    </Flex>
  );
};

export default CaseDocumentEmptyCard;
